(() => {
  const escapeHtml = (value) => String(value).replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  }[char]));

  const escapeAttribute = (value) => escapeHtml(value).replace(/`/g, '&#96;');
  const normalizeQuery = (value) => String(value || '').trim().replace(/\s+/g, ' ').toLocaleLowerCase();

  const localizePath = (value) => {
    const path = String(value || '');
    const localeRoot = window.Shopify?.routes?.root || '/';
    if (localeRoot === '/' || !path.startsWith('/') || path.startsWith(localeRoot)) return path;
    return `${localeRoot.replace(/\/$/, '')}${path}`;
  };

  const highlightQuery = (value, query) => {
    const title = String(value || '');
    const needle = String(query || '').trim();
    if (!needle) return escapeHtml(title);
    const index = title.toLocaleLowerCase().indexOf(needle.toLocaleLowerCase());
    if (index < 0) return escapeHtml(title);

    return [
      escapeHtml(title.slice(0, index)),
      `<strong data-predictive-search-match>${escapeHtml(title.slice(index, index + needle.length))}</strong>`,
      escapeHtml(title.slice(index + needle.length)),
    ].join('');
  };

  const brandItems = (products, query, labels) => {
    const normalizedQuery = normalizeQuery(query);
    const seen = new Set();

    return products.reduce((items, product) => {
      const vendor = String(product.vendor || '').trim();
      const normalizedVendor = normalizeQuery(vendor);
      if (!vendor || !normalizedVendor.includes(normalizedQuery) || seen.has(normalizedVendor)) return items;

      seen.add(normalizedVendor);
      items.push({
        title: [labels.brandPrefix, vendor].filter(Boolean).join(' '),
        type: labels.brands,
        url: `/search?q=${encodeURIComponent(vendor)}&type=product`,
      });
      return items;
    }, []).slice(0, 4);
  };

  const itemTemplate = (item, groupKey = '', query = '') => {
    const title = item.title || item.text || '';
    const imageSource = typeof item.image === 'string'
      ? item.image
      : item.image?.url || item.featured_image?.url || '';
    const image = imageSource
      ? `<img src="${escapeAttribute(imageSource)}" alt="" loading="lazy" data-predictive-search-image>`
      : '<span class="predictive-search__placeholder" aria-hidden="true"></span>';
    const itemUrl = localizePath(item.url);
    const isSuggestion = groupKey === 'suggestions';
    const titleHtml = isSuggestion ? highlightQuery(title, query) : escapeHtml(title);
    const suggestionAttribute = isSuggestion
      ? ` data-predictive-search-suggestion="${escapeAttribute(title)}"`
      : '';
    const leading = groupKey === 'products'
      ? image
      : `<span class="predictive-search__placeholder predictive-search__symbol predictive-search__symbol--${escapeAttribute(groupKey)}" aria-hidden="true"></span>`;

    return `
      <li class="predictive-search__item predictive-search__item--${escapeAttribute(groupKey)}" data-predictive-search-item>
        <a href="${escapeAttribute(itemUrl)}" data-predictive-search-link${suggestionAttribute}>
          ${leading}
          <span>
            <span class="predictive-search__title" data-predictive-search-title>${titleHtml}</span>
            <span class="predictive-search__type" data-predictive-search-type>${escapeHtml(item.type)}</span>
          </span>
        </a>
      </li>
    `;
  };

  window.LetoilePredictiveSearchView = {
    brandItems,
    highlightQuery,
    itemTemplate,
  };
})();
